import type { IconDefinition } from '../index.tsx';

export const iconGrid: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconGrid',
  icon: [
    16,
    16,
    [],
    '',
    'M1 1H7V7H1V1Z M9 1H15V7H9V1Z M1 9H7V15H1V9Z M9 9H15V15H9V9Z',
  ],
};
